var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLimiter = function SvgLimiter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m14.842 9.279 5.192-5.192-.707-.707-5.192 5.192V4.597h-1v5.682h5.682v-1zM4.488 19.633 9.68 14.44v3.974h1v-5.681H4.998v1h3.975l-5.192 5.192z"
  })));
};
export default SvgLimiter;